module.exports = __webpack_public_path__ + "img/12-03_Empowering People.a10a6856.svg";